import { Component, input, output } from "@angular/core";
import { ButtonModule } from "primeng/button";

export type SectionHeaderAlign = "center" | "left";

/**
 * Standardized section / page header.
 *
 * Title (+ optional subtitle) with an optional leading back button and a
 * trailing actions slot (`[headerActions]`). Generalizes the various
 * `detail-header` / `sheet-header` snippets so headers share one layout,
 * type scale and spacing.
 */
@Component({
  selector: "app-section-header",
  standalone: true,
  imports: [ButtonModule],
  templateUrl: "./section-header.component.html",
  styleUrl: "./section-header.component.scss"
})
export class SectionHeaderComponent {
  title = input<string>("");
  subtitle = input<string>("");
  /** Show a leading back chevron that emits `back`. */
  showBack = input<boolean>(false);
  /** Title alignment. */
  align = input<SectionHeaderAlign>("center");
  testId = input<string>("app-section-header");

  /** Emitted when the back button is pressed. */
  readonly back = output<void>();
}
